import React, { useCallback, useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const Barcode = ({ value, forceLandscape = false }) => {
  const barcodeRef = useRef(null);

  const generateBarcode = useCallback(() => {
    if (!barcodeRef.current) {
      return;
    }
    const isLandscapeMatch =
      typeof window !== 'undefined' && window.matchMedia('(orientation: landscape)').matches;
    const shouldUseLandscape = forceLandscape || isLandscapeMatch;
    JsBarcode(barcodeRef.current, value.replace(/^['"](.+(?=['"]$))['"]$/, '$1'), {
      format: 'CODE128',
      lineColor: '#000',
      width: shouldUseLandscape ? 2.4 : 1.5,
      height: shouldUseLandscape ? 160 : 120,
      displayValue: false,
      margin: shouldUseLandscape ? 20 : 0,
    });
  }, [value, forceLandscape]);

  useEffect(() => {
    generateBarcode();

    if (typeof window === 'undefined') {
      return undefined;
    }

    const orientationQuery = window.matchMedia('(orientation: landscape)');
    const handler = () => generateBarcode();

    if (orientationQuery.addEventListener) {
      orientationQuery.addEventListener('change', handler);
    } else if (orientationQuery.addListener) {
      orientationQuery.addListener(handler);
    }

    return () => {
      if (orientationQuery.removeEventListener) {
        orientationQuery.removeEventListener('change', handler);
      } else if (orientationQuery.removeListener) {
        orientationQuery.removeListener(handler);
      }
    };
  }, [generateBarcode]);

  return <svg ref={barcodeRef}></svg>;
};

export default Barcode;
